import React from "react";
import styles from "./style.scss";
import cn from "classnames";

export const SkeletonTab: React.FunctionComponent = () => {
  return (
    <div className={styles.tabWrapper}>
      <div className={cn(styles.tab, styles.skeletonText)} />
    </div>
  );
};
